import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";

export default function StickyMobileCTA() {
  const site = useSite();
  const location = useLocation();
  if (["/quote", "/thank-you", "/admin", "/admin/login", "/schedule"].includes(location.pathname)) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur-md border-t border-navy-100 shadow-[0_-4px_20px_rgba(11,27,61,0.12)]"
      data-testid="sticky-mobile-cta">
      <div className="grid grid-cols-2 gap-2 p-2.5">
        <a href={`tel:${site.phone_href}`} className="btn-primary !px-3 !py-3 !text-base"
          onClick={() => track("phone_click", { location: "sticky_mobile" })} data-testid="sticky-call-button">
          <Phone className="h-4 w-4" aria-hidden="true" /> Call Michael
        </a>
        <Link to="/quote" className="btn-accent !px-3 !py-3 !text-base"
          onClick={() => track("cta_click", { location: "sticky_mobile", action: "get_quote" })} data-testid="sticky-quote-button">
          Get a Quote
        </Link>
      </div>
    </div>
  );
}
